var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.91 15.788a9 9 0 1 1 .717-.698l1.06 1.062a2.001 2.001 0 0 1 2.43.309l4.49 4.489a1 1 0 0 1 0 1.414l-1.415 1.414a1 1 0 0 1-1.414 0L16.29 19.29a2 2 0 0 1-.309-2.43l-1.07-1.07ZM17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0Zm5.9 12.657-4.49-4.49a1 1 0 0 0-1.414 1.415l4.49 4.49 1.413-1.415Z"
})));
export default SvgSearchinline;